var _excluded = ["className", "fontSize", "width", "height", "color"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import SVGWrapper from '../svg-wrapper/component';

var InfoIcon = function InfoIcon(_ref) {
  var className = _ref.className,
      fontSize = _ref.fontSize,
      width = _ref.width,
      height = _ref.height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#474B5E' : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(SVGWrapper, {
    className: className,
    fontSize: fontSize,
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 17",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    color: color
  }), /*#__PURE__*/React.createElement("title", null, "Info Icon"), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: color,
    d: "M8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5C17 13.1944 13.1944 17 8.5 17ZM8.49997 15.533C12.3842 15.533 15.533 12.3842 15.533 8.49997C15.533 4.61575 12.3842 1.46697 8.49997 1.46697C4.61575 1.46697 1.46697 4.61575 1.46697 8.49997C1.46697 12.3842 4.61575 15.533 8.49997 15.533ZM6.47159 7.2056C6.47159 7.6107 6.79999 7.9391 7.20509 7.9391H7.76601V11.6498H7.20509C6.79999 11.6498 6.47159 11.9782 6.47159 12.3833C6.47159 12.7884 6.79999 13.1168 7.20509 13.1168H9.79393C10.199 13.1168 10.5274 12.7884 10.5274 12.3833C10.5274 11.9782 10.199 11.6498 9.79393 11.6498H9.23301V7.2056C9.23301 6.80049 8.90461 6.47209 8.49951 6.47209H7.20509C6.79999 6.47209 6.47159 6.80049 6.47159 7.2056ZM8.49964 5.35303C9.08346 5.35303 9.55674 4.87974 9.55674 4.29592C9.55674 3.71224 9.08369 3.23904 8.49921 3.23881C7.91558 3.23904 7.44253 3.71224 7.44253 4.29592C7.44253 4.87974 7.91581 5.35303 8.49964 5.35303Z"
  })));
};

export default InfoIcon;